module.exports = __webpack_public_path__ + "img/logo-simple.5d5fcba7.png";